<template>
  <div class="apply-content">
    <div class="header">
      <img class="header-logo" :src="$store.state.static_img_url + 'pic/logo.png'" />
    </div>
    <div class="content">
      <p class="head-p">动脉智库3.0试用申请</p>
      <div class="one-desc">动脉智库3.0为企业、金融机构和政府提供更专业<br>全面的功能及服务。</div>
      <Form ref="apply-form" :model="params" label-position="top" :rules="form_rules">
        <FormItem label="关注的领域" prop="sel_ly">
          <Select v-model="params.sel_ly" multiple :max-tag-count="1">
            <Option :value="item" v-for="item,index in tag_list" :key="index">{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem label="姓名" prop="name">
          <Input v-model="params.name" placeholder="请输入姓名" />
        </FormItem>
        <FormItem label="手机号" prop="mobile">
          <Input v-model="params.mobile" placeholder="请输入联系电话" />
        </FormItem>
        <FormItem label="验证码" prop="code" class="code">
          <Input v-model="params.code" placeholder="请输入验证码"></Input>
          <Captcha
            ref="captcha"
            :mobile="params.mobile"
          ></Captcha>
        </FormItem>
        <FormItem label="公司或机构" prop="comp_name">
          <Input v-model="params.comp_name" placeholder="请输入公司或机构" />
        </FormItem>
        <FormItem label="职位" prop="title">
          <Input v-model="params.title" placeholder="请输入职位" />
        </FormItem>
        <FormItem label="上传名片" prop="name_card_path">
          <Upload :action="`${this.req_url3}/api/user/file`" :before-upload="handleBeforeUpload" :show-upload-list="false" v-if="!params.name_card_path">
            <div class="upload-warpper">
              <i class="iconfont">&#xe730;</i>
              <p>上传图片</p>
            </div>
          </Upload>
          <div class="upload-warpper active" v-else>
            <i class="iconfont del-icon" @click="params.name_card_path = ''">&#xe6bb;</i>
            <img :src="params.name_card_path" @click="handlePreviewPic(params.name_card_path, 2)" />
          </div>
        </FormItem>
        <FormItem label="需求">
          <Input v-model="params.summary" placeholder="请输入需求描述" />
        </FormItem>
      </Form>
    </div>
    <div class="footer">
      <button @click="submitForm">提交申请</button>
      <p>提交信息后，我们会在1~2个工作日审核，<br><span>虚假信息不予通过</span>，审核通过后，会与您取得联系，<br>请保持电话通畅。</p>
    </div>
  </div>
</template>
<script>
import { checkUserBehavior, addtryapplynew, addTryEnterPV } from '@/service'
import Captcha from '@/components/Captcha'
import axios from 'axios'
import { mapState } from 'vuex'
export default {
  components: {
    Captcha
  },
  data() {
    return {
      tag_list: [
        '生物医药',
        '器械-应用科室',
        '器械-热门类别',
        '智慧医疗',
        '互联网+医疗健康',
        '数字疗法',
        '器械应用科室-IVD',
      ],
      params: {
        name: '',
        comp_name: '',
        title: '',
        summary: '',
        mobile: '',
        sel_ly: [],
        code: '',
        name_card_path: '',
      },
      form_rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        name_card_path: [{ required: true, message: '请上传名片', trigger: 'change' }],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            type: 'number',
            message: '手机号格式不正确',
            trigger: 'blur',
            transform(value) {
              let reg = /^1[3456789]\d{9}$/
              if (!reg.test(value)) {
                return false
              } else {
                return Number(value)
              }
            },
          },
        ],
        comp_name: [{ required: true, message: '请输入公司或机构', trigger: 'blur' }],
        title: [{ required: true, message: '请输入职位', trigger: 'blur' }],
        summary: [{ required: true, message: '请输入需求描述', trigger: 'blur' }],
        sel_ly: [
          { required: true, type: 'array', min: 1, message: '请选择申请领域', trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      req_url3: (state) => state.req_url3,
    }),
  },
  beforeDestroy() {},
  methods: {
    async addTryEnterPV() {
      let res = await addTryEnterPV(
        {
          info_src: 31,
          userid: this.$store.state.user.id,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
    },
    submitForm() {
      this.$refs['apply-form'].validate(async (valid) => {
        if (valid) {
          let txt = this.params.sel_ly.join('，')
          let form_params = {
            user_key: this.$store.state.user_key || '',
            name: this.params.name,
            comp_name: this.params.comp_name,
            title: this.params.title,
            summary:
              '申请体验版块：“动态资讯库、产业知识库、行业数据库”；申请体验领域：“' +
              txt +
              '”。' +
              this.params.summary,
            info_src: 31,
            mobile: this.params.mobile,
            code: this.params.code,
            scene: 'vbdata_try_enter',
          }
          let res = await addtryapplynew(form_params, (error) => {
            this.$Message.error('请求失败！')
          })
          if (res.status == 'success') {
            this.$router.push({ name: 'MApplySuccess' })
          } else {
            this.$Message.error(res.message)
          }
        }
      })
    },
    handleBeforeUpload(file) {
      const imageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif']
      if (!imageTypes.includes(file.type)) {
        this.$Message.error('请上传jpeg、jpg、png或gif格式的图片文件')
        return false
      }

      if (file.size / 1024 / 1024 > 100) {
        this.$Message.error('文件大小请限制在100M以内')
        return false
      }

      let timestamp
      let crc32 = function (r) {
        for (var a, o = [], c = 0; c < 256; c++) {
          a = c
          for (var f = 0; f < 8; f++) a = 1 & a ? 3988292384 ^ (a >>> 1) : a >>> 1
          o[c] = a
        }
        for (var n = -1, t = 0; t < r.length; t++) n = (n >>> 8) ^ o[255 & (n ^ r.charCodeAt(t))]
        return (-1 ^ n) >>> 0
      }
      let timestamp_org = Math.trunc(new Date().getTime() / 1000)
      let timestamp_crc = String(crc32(String(timestamp_org))).substring(0, 3)
      timestamp = Number(timestamp_org + timestamp_crc)

      const formData = new FormData()
      formData.append('files', file)

      axios
        .post(`${this.req_url3}/api/user/file`, formData, {
          headers: {
            'content-Type': 'multipart/form-data',
            timestamp: timestamp,
          },
        })
        .then((response) => {
          const res = response.data
          if (res.code == 0 && res.data.length) {
            this.params.name_card_path = res.data[0]
          } else {
            this.$Message.error(res.msg)
          }
        })
        .catch((error) => {
          this.$Message.error('请求错误!')
        })

      return false
    },
  },
  mounted() {
    this.addTryEnterPV()
  },
}
</script>
<style lang="stylus" scoped>
.apply-content
  background #fff
  border solid #EEEEEE 0.5rem
  padding 0.3rem 0.3rem 0.4rem
  min-height 100vh
  .header
    border-bottom solid #EEEEEE 0.02rem
    padding-bottom 0.3rem
    text-align center
    font-size 0
    .header-logo
      width auto
      height 0.5rem
  .content
    .head-p
      color #333333
      font-size 0.28rem
      text-align center
      padding 0.3rem 0
    .one-desc
      font-size 0.24rem
      font-weight 500
      color #999
      line-height 0.36rem
      margin-top -0.06rem
      margin-bottom 0.3rem
      text-align center
    .nc-cnt
      width 300px
      height 34px
      margin -2px auto 18px
      >>> .nc_scale
        span
          box-sizing content-box
          &.nc-lang-cnt
            display inline !important
    .ivu-input, .ivu-select-selection, >>> .ivu-form-item
      margin-bottom 0.44rem
      .ivu-form-item-content
        line-height 1
          border 1px solid #DCDFE6
          border-radius 0.04rem
          font-size 0.24rem
        .ivu-form-item-error-tip
          padding-top 4px
      &.ivu-form-item-error
        .ivu-input, .ivu-select-selection
          border 1px solid #ed4014
      &.code
        .ivu-form-item-content
          position relative
          display flex
          justify-content space-between
          align-items center
          .ivu-input-wrapper
            width calc(100% - 2.2rem)
          .code-btn
            width 2rem
            height .64rem
            border 0
            background #FA7F50
            box-shadow none
            outline none
            color #fff
            line-height 1
            font-size 0.24rem
            display flex
            align-items center
            justify-content center
            border-radius 0
            &[disabled]
              background #ccc
              color #FFF
      .ivu-upload-select
        display block
  .upload-warpper
    width 100%
    height 100px
    border 1px dashed #CCCCCC
    display flex
    align-items center
    justify-content center
    cursor pointer
    transition all 0.3s
    overflow hidden
    position relative
    border-radius: 4px;
    &.active
      border 0
    &:active
      border-color #aaa
      .iconfont
        color #666
        &.del-icon
          color rgba(0, 0, 0, 0.5)
      p
        color #666
    .iconfont
      transition all 0.3s
      font-size 16px
      color #999999
      &.del-icon
        color rgba(0, 0, 0, 0.5)
        position absolute
        font-size 18px
        right 5px
        top 5px
        line-height 1
        z-index 10
        &:active
          color rgba(0, 0, 0, 0.7)
    p
      transition all 0.3s
      font-size 14px
      color #999999
      line-height 1
      margin-left 4px
    img
      transition all 0.3s
      width 100%
      height 100%
      object-fit cover
  .footer
    border-top solid #EEEEEE 0.02rem
    padding-top 0.4rem
    text-align center
    button
      width 2rem
      height 0.6rem
      background #FA7A50
      border-radius 0.04rem
      font-size 0.26rem
      font-weight 500
      color #FFFFFF
    p
      font-size 0.22rem
      font-weight 500
      color #999999
      line-height 0.36rem
      margin-top 0.3rem
      span
        color #ff9924
</style>